"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCalendarNavigationIcons = exports.defaultDayPickerStrings = exports.defaultCalendarStrings = void 0;
var date_time_utilities_1 = require("@fluentui/date-time-utilities");
exports.defaultCalendarStrings = date_time_utilities_1.DEFAULT_CALENDAR_STRINGS;
/**
 * @deprecated Use `defaultCalendarStrings`
 */
exports.defaultDayPickerStrings = exports.defaultCalendarStrings;
exports.defaultCalendarNavigationIcons = {
    leftNavigation: 'Up',
    rightNavigation: 'Down',
    closeIcon: 'CalculatorMultiply',
};
//# sourceMappingURL=defaults.js.map